export default __webpack_public_path__ + "static/media/marker.f84c1493.png";